import { render, staticRenderFns } from "./RegisterStudyFormNewVersion.vue?vue&type=template&id=f48659d2&scoped=true"
import script from "./RegisterStudyFormNewVersion.vue?vue&type=script&lang=js"
export * from "./RegisterStudyFormNewVersion.vue?vue&type=script&lang=js"
import style0 from "./RegisterStudyFormNewVersion.vue?vue&type=style&index=0&id=f48659d2&prod&scoped=true&lang=css"
import style1 from "./RegisterStudyFormNewVersion.vue?vue&type=style&index=1&id=f48659d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48659d2",
  null
  
)

export default component.exports